/**
 * A global namespace for `ArrowDown` key.
 * e.which = 40 equivalent
 */
const keyArrowDown = 'ArrowDown';

export default keyArrowDown;
